import React, { useEffect } from "react";
import { colors } from "../../colors";

type Props = {
  searchQuery: string;
  setSearchQuery: React.Dispatch<React.SetStateAction<string>>;
};

const SearchBox = ({ searchQuery, setSearchQuery }: Props) => {
  useEffect(() => {
    const savedQuery = localStorage.getItem("searchQuery");
    if (savedQuery) {
      setSearchQuery(savedQuery);
    }
  }, [setSearchQuery]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchQuery(value);
    localStorage.setItem("searchQuery", value);
  };

  return (
    <div>
      <input
        type="text"
        placeholder="Search by Repo Name..."
        value={searchQuery}
        onChange={handleChange}
        className="border p-2 rounded-lg lg:w-52 w-full shadow-md shadow-black-100"
        style={{ borderColor: colors.searchInputBorder }}
      />
    </div>
  );
};

export default SearchBox;
